import React from 'react'
import { Link, Navigate, useParams } from 'react-router-dom'
import ClaimFormTemplatesPage from './ClaimFormTemplates'
import ClaimInsurerFaxSettingsPage from './ClaimInsurerFaxSettings'

const CLAIM_FORM_TABS = [
  { key: 'templates', label: '청구서식', path: '/ops/forms/claims/templates', Component: ClaimFormTemplatesPage },
  { key: 'fax', label: '청구번호', path: '/ops/forms/claims/fax', Component: ClaimInsurerFaxSettingsPage },
]

export default function ClaimFormsManagementPage() {
  const { tab } = useParams()
  const activeTab = CLAIM_FORM_TABS.find((item) => item.key === tab)

  if (!activeTab) {
    return <Navigate to="/ops/forms/claims/templates" replace />
  }

  const ActivePage = activeTab.Component

  return (
    <section className="space-y-4">
      <header className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">서식관리 &gt; 청구서식</h1>
        </div>
        <div className="flex flex-wrap gap-2 text-sm">
          <Link className="rounded border px-3 py-1.5 hover:bg-slate-50" to="/support/claims">보험금 청구</Link>
          <Link className="rounded border px-3 py-1.5 hover:bg-slate-50" to="/support/claims/applications">청구 이력</Link>
        </div>
      </header>

      <div className="border-b border-slate-200">
        <nav className="-mb-px flex flex-wrap gap-1" aria-label="청구서식 탭">
          {CLAIM_FORM_TABS.map((item) => {
            const active = item.key === activeTab.key
            return (
              <Link
                key={item.key}
                to={item.path}
                aria-current={active ? 'page' : undefined}
                className={`inline-flex min-h-[2.75rem] items-center border-b-2 px-3 text-sm font-semibold transition-colors ${
                  active
                    ? 'border-brand-navy text-brand-navy'
                    : 'border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-800'
                }`}
              >
                {item.label}
              </Link>
            )
          })}
        </nav>
      </div>

      <ActivePage embedded />
    </section>
  )
}
